module.exports = __webpack_public_path__ + "img/11.4a40a159.png";